import React, { useState } from 'react';
import './AboutSection.css';
import ProgressBar from './ProgressBar';

const AboutSection = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAbout = () => {
    setIsOpen(!isOpen);
  };

  return (
    <section id="about" className="about-section">
      <div className="about-header" onClick={toggleAbout}>
        <h2>About Me</h2>
        <svg
          className={`arrow ${isOpen ? 'open' : ''}`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M6 9l6 6 6-6" />
        </svg>
      </div>
      {isOpen && (
        <div className="about-content">
          <img src="boy1.png" alt="Hamid Jabbar" className="about-image" />
          <p className="about-text">
            My name is Hamid Jabbar. I am a creative and dedicated website developer specializing in React.js, with two years of professional experience. Throughout my career, I have successfully developed numerous projects that have met and exceeded client expectations. My portfolio includes collaborations with several well-known companies, showcasing my ability to deliver high-quality web solutions. I hold a Master's degree in Computer Science (MCS), which has provided me with a strong foundation in both theoretical and practical aspects of web development.
          </p>
          <div className="skills-container">
            <div className="skill">
              <ProgressBar percentage={90} text="HTML" />
            </div>
            <div className="skill">
              <ProgressBar percentage={85} text="CSS" />
            </div>
            <div className="skill">
              <ProgressBar percentage={80} text="JavaScript" />
            </div>
            <div className="skill">
              <ProgressBar percentage={81} text="React" />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default AboutSection;
